<template>
  <v-sheet class="pa-4" color="grey lighten-4 text-subtitle-1" rounded>
    <v-row dense>
      <v-col cols="12">
        <div class="d-flex">
          <strong class="mr-auto">{{ $t('ORDERS.SUB_QUESTIONS') }}:</strong>

          <v-btn
            v-if="(text || '').length"
            small
            tile
            depressed
            class="text-none font-weight-regular ml-auto px-2"
            @click="confirm"
          >
            <v-icon class="mr-1" small>mdi-eye-outline</v-icon>
            {{ $t('ITEM.VIEW') }}
          </v-btn>
        </div>
        <confirm-dialog ref="confirm"
          ><template v-slot:buttons
            ><v-textarea readonly :value="text"></v-textarea
          ></template>
        </confirm-dialog>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  name: 'OrderSubQuestions',

  components: {
    ConfirmDialog: () => import('@/modules/_global/_components/ConfirmDialog')
  },

  props: {
    text: {
      type: String,
      default: ''
    }
  },

  methods: {
    confirm() {
      this.$refs.confirm.open(this.$t('ORDERS.SUB_QUESTIONS'), null, {
        messageClass: 'px-4'
      });
    }
  }
};
</script>

<style scoped></style>
